import React, { memo, useMemo } from "react";
import useDefaultEvent from "./index.hooks";
import { CardActions, Grid, Tooltip, Typography } from "@material-ui/core";
import { Event } from "models";
import {
  AppButton,
  AppDashedAddButton,
  AppPaper,
  CreateDefaultEventDialog,
  CreateEventDialog,
  DefaultEventCard,
  EventPreview,
} from "../";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";

type DefaultEventProps = {};

const DefaultEvent = ({}: DefaultEventProps) => {
  const {
    styles,
    classes,
    atomicStyles,
    merchant,
    event,
    handleCreateDefaultEventDialogOpen,
  } = useDefaultEvent();

  return (
    <Grid
      container
      direction="column"
      justify="space-around"
      alignItems="stretch"
      className={styles.gridContainer}
    >
      <Grid item>
        <CreateDefaultEventDialog />
        {merchant.defaultEvent ? (
          <EventPreview
            event={event}
            isDefault={true}
            buttonOnClick={handleCreateDefaultEventDialogOpen}
          />
        ) : (
          <Tooltip title={"DefaultEvent"} enterTouchDelay={1}>
            <AppDashedAddButton onClick={handleCreateDefaultEventDialogOpen} />
          </Tooltip>
        )}
      </Grid>
    </Grid>
  );
};

export default memo(DefaultEvent);
